module.exports = __webpack_public_path__ + "img/archives_banner.a32766b1.png";